import React, { useState } from "react";
import ButtonGroup from '@visa/vds/button-group';
import ButtonText from '@visa/vds/button-text';
import Dialog from '@visa/vds/dialog';
import DialogCardBody from '@visa/vds/dialog-card-body';
import DialogCardFooter from '@visa/vds/dialog-card-footer';
import DialogCardHead from '@visa/vds/dialog-card-head';
import DialogCardHeadTitle from '@visa/vds/dialog-card-head-title';

const DafTabRequestDialog = (props) => {
    let openDialog = props.openDialog;
    let setCloseDialog = props.setCloseDialog;

    return (
        <Dialog titleId="dialog-title-tab-request" aria-describedby="dialog-description-tab-request"
            open={openDialog} onExit={setCloseDialog}>
            <DialogCardHead>
                <DialogCardHeadTitle id="dialog-title-tab-request">{props.dialogTitle}</DialogCardHeadTitle>
            </DialogCardHead>
            <DialogCardBody id="dialog-description-tab-request">
                {props.renderDialogBody()}
            </DialogCardBody>
            <DialogCardFooter>
                <ButtonGroup direction="right">
                    <ButtonText colorScheme="secondary" onClick={setCloseDialog}>Close</ButtonText>
                </ButtonGroup>
            </DialogCardFooter>
        </Dialog>
    );
};
export default DafTabRequestDialog;
